import { getOffers, getOffer, getHotOffers, getHotOffer } from './action';

export { offersReducer } from './reducer';
export { watchOffers } from './saga';
export {
  GET_OFFERS,
  GET_OFFERS_SUCCESS,
  GET_HOT_OFFERS,
  GET_HOT_OFFER,
} from './types';

export const offersAction = {
  getOffers,
  getOffer,
  getHotOffers,
  getHotOffer,
};
